import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { BillingForm } from "@/components/app/BillingForm";

export function BillingDialog({ open, onOpenChange, onSaved }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Rechnungsdaten</DialogTitle>
          <DialogDescription>
            Aus Gründen der EU-Umsatzsteuer benötigen wir diese Angaben einmalig vor deinem ersten Kauf.
          </DialogDescription>
        </DialogHeader>
        <BillingForm onSaved={onSaved} />
      </DialogContent>
    </Dialog>
  );
}
